module.exports = __webpack_public_path__ + "img/check-circle.817afcdf.svg";